import {
  differenceInCalendarDays,
  isToday,
  isYesterday,
  startOfDay,
  subMonths,
} from 'date-fns';

export function portalReleaseToDate(
  value: Date | { toDate?: () => Date } | undefined,
): Date | null {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const converted = value.toDate?.();
  return converted instanceof Date && !Number.isNaN(converted.getTime()) ? converted : null;
}

/** Subtle client-facing stamp for when a portal release version was published. */
export function formatPortalReleaseAddedAt(
  value: Date | { toDate?: () => Date } | undefined,
  now: Date = new Date(),
): string | null {
  const date = portalReleaseToDate(value);
  if (!date) return null;

  const timePart = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });

  if (isToday(date)) return `Today · ${timePart}`;
  if (isYesterday(date)) return `Yesterday · ${timePart}`;

  const daysAgo = differenceInCalendarDays(startOfDay(now), startOfDay(date));
  if (daysAgo >= 2 && daysAgo <= 6) return `${daysAgo} days ago`;
  if (daysAgo >= 7 && daysAgo <= 13) return 'Last week';

  const oneMonthAgo = startOfDay(subMonths(now, 1));
  if (date >= oneMonthAgo) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: now.getFullYear() !== date.getFullYear() ? 'numeric' : undefined,
  });
}
